



























































































import { Vue, Component, Prop } from 'vue-property-decorator';
import AMSformTable from '../../../components/AMSformTable.vue';
import AMSTable from '../../../components/AMSTable.vue';
import AMSImg from '../../../components/AMSImg.vue';
import request from '@/utils/request';
import { AppStore } from '@/store/modules/app';
import moment from 'moment';
import AMSBreadcrumb from '@/components/AMSBreadcrumb.vue';
import AMSOperateLogs from '@/components/AMSOperateLogs.vue';
import AMSDialog from '@/components/AMSDialog.vue';
import { getStockLog, approveStock } from '@/api/stock';
interface Product {
  name?: string;
  serialNumber?: string;
  capacity?: string;
  orderPrice?: Number;
  sort?: Number;
  stockQuantity?: Number;
  category?: Warehouse;
  creationTime?: String;
  status?: string;
  id?: string;
}
interface Products {
  stockId?: string;
  productId?: string;
  product?: Product;
  quantity?: Number;
}
interface Warehouse {
  name?: string;
  id?: string;
}
interface Form {
  warehouseId?: string;
  warehouse?: Warehouse;
  products?: Products[];
  number?: string;
  type?: string;
  quantity?: Number;
  operator?: string;
  stockTime?: String;
  status?: string;
  id?: string;
  orderId?: string;
}

@Component({
  components: {
    'ams-formtable': AMSformTable,
    'ams-table': AMSTable,
    'ams-dialog': AMSDialog,
    'ams-breadcrumb': AMSBreadcrumb,
    'ams-operate-logs': AMSOperateLogs
  }
})
export default class outStockDetail extends Vue {
  breadcrumbsItems = [
    {
      text: '库存管理',
      disabled: false,
      href: '/outStock'
    },
    {
      text: '出库单',
      disabled: false,
      href: '/outStock'
    },
    {
      text: this.isEdit() ? '审核出库单' : '出库单详情',
      disabled: true
    }
  ];
  form: Form = {};
  logs: Array<any> = [];
  headers = [
    { text: '编号', value: 'serialNumber', sortable: false, align: 'right' },
    {
      text: '图片',
      value: 'pictureKey',
      sortable: false,
      align: 'left',
      render: (h: Function, param: any) => {
        return h(AMSImg, {
          props: {
            pictureKey: param.row.pictureKey,
            pictureWidth: 40,
            pictureHeight: 40
          }
        });
      }
    },
    { text: '商品名称', value: 'name', sortable: false, align: 'left' },
    { text: '容量', value: 'capacity', sortable: false, align: 'left' },
    {
      text: '出库数',
      value: 'quantity',
      sortable: false,
      align: 'right',
      edit: () => {
        return this.isEdit();
      }
    },
    {
      text: '限用日期',
      value: 'productionDate',
      sortable: false,
      align: 'left',
      isDatePicker: () => {
        return this.isEdit();
      }
    }
  ];
  records = [
    { text: '操作者', value: 'operator', sortable: false, align: 'left' },
    { text: '操作时间', value: 'operateTime', isFormatDate: true, sortable: false, align: 'left' },
    { text: '操作类型', value: 'operateType', sortable: false, align: 'left' },
    {
      text: '说明',
      value: 'propetyChanges',
      sortable: false,
      align: 'left',
      render: (h: Function, param: any) => {
        let content = '';
        param.row[param.keyName].forEach((i: any) => {
          content += `原 ${i.propertyName} 由 <span style="color:#00a679">${i.originalValue ? i.originalValue : '空'}</span>
          修改为 <span style="color:red">${i.newValue ? i.newValue : '空'}</span>`;
          content += '<br />';
        });
        return h('div', {
          domProps: {
            innerHTML: content
          }
        });
      }
    }
  ];
  dialog = false;
  get totalProducts() {
    if (!this.form.products) return 0;
    return this.form.products.filter((p: any) => {
      return p.id;
    }).length;
  }
  plus(a: number, b: number) {
    return a + b;
  }
  get totalQuantity(): number {
    if (!this.form.products) return 0;
    return this.form.products
      .map((item: any) => {
        return parseInt(item.quantity);
      })
      .reduce(this.plus, 0);
  }
  get isNoQuantity() {
    let error = false;
    this.form.products!.forEach((p: any) => {
      if (!p.quantity) {
        error = true;
      }
    });
    return error;
  }
  get shortageProducts() {
    let productNames: any = [];
    if (!this.form.products) return [];
    this.form.products!.forEach((p: any) => {
      if (p.stockQuantity - p.quantity < 0) {
        productNames.push(p.name);
      }
    });
    return productNames;
  }
  isEdit() {
    return !this.$route.query.isDetail;
  }
  created() {
    this.getFormData();
    this.getLog();
  }
  goToOrderDerails(form: any) {
    if (form.type === 'Order') {
      this.$router.push({ name: 'orderList_details', query: { id: form.orderId } });
    } else {
      this.$router.push({ name: 'materials_view', query: { id: form.orderId } });
    }
  }
  formatDate(date: Date) {
    return moment(date).format('YYYY-MM-DD');
  }
  getFormData() {
    request.get(`/api/Stock/${this.$route.query.id}`).then((data: any) => {
      this.form = data;
      this.form.products =
        this.form.products != null
          ? this.form.products.map((p: any) => {
              return Object.assign({}, p, { productionDate: p.productionDate ? moment(p.productionDate).format('YYYY-MM-DD') : null });
            })
          : [];
    });
  }
  getLog() {
    request.get(`/api/Stock/${this.$route.query.id}/logs`).then((data: any) => {
      this.logs = data.items;
    });
  }
  back() {
    this.$router.go(-1);
  }
  approve() {
    if (this.isNoQuantity) {
      AppStore.ShowError(`出库数量不能为空`);
      return;
    }
    this.dialog = true;
  }
  cancel() {
    this.dialog = false;
  }
  sure() {
    let formData = this.form.products!.map((p: any) => {
      return { productId: p.id, quantity: p.quantity, productionDate: p.productionDate };
    });
    approveStock(this.$route.query.id.toString(), formData)
      .then((data: any) => {
        this.$router.push({ name: 'outStock' });
      })
      .catch()
      .finally(() => {
        this.dialog = false;
      });
  }
  switchStatus(status: string) {
    switch (status) {
      case 'Pending':
        return '待审核';
      case 'Stocked':
        return '已出库';
      case 'Cancel':
        return '已取消';
    }
  }
  switchType(type: string) {
    switch (type) {
      case 'PurchaseReturn':
        return '采购退货';
      case 'Order':
        return '销售出库';
      case 'TransferOut':
        return '调拨出库';
      case 'Loss':
        return '盘亏出库';
      case 'OtherOut':
        return '其他出库';
      case 'MaterialOrder':
        return '物料申请出库';
    }
  }
}
